import React from "react";
import { useNavigate } from "react-router-dom";

const BlogItem = ({ data }) => {
  const navigate = useNavigate();

  const handleBlogClick = (slug) => {
    navigate(`/blogs/${slug}`);
  };

  return (
    <div
      className="blog-item style-list h-full cursor-pointer transition-all duration-300 p-2 sm:p-3 rounded-2xl "
      onClick={() => handleBlogClick(data.slug)}
    >
      <div
        className="blog-main h-full flex flex-col md:flex-row md:items-center gap-6 md:gap-6 lg:gap-9"
        style={{ fontFamily: "InstrumentSans" }}
      >
        <div className="blog-thumb w-full md:w-1/2 h-56 sm:h-64 md:h-auto rounded-2xl overflow-hidden flex-shrink-0">
          <img
            src={data.thumbImg || "/api/placeholder/600/400"}
            alt={data.h1Heading}
            className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
          />
        </div>
        <div className="blog-infor flex flex-col w-full md:w-1/2 px-2 md:px-0 ">
          <div className="heading6 blog-title font-bold text-lg sm:text-xl md:text-2xl transition-colors duration-300 hover:text-gray-700">
            {data.h1Heading}
          </div>

          <div className="flex items-center gap-2 mt-2">
            <div className="blog-author text-xs sm:text-sm text-gray-600">
              by {data.author}
            </div>
            <span className="w-4 h-px bg-gray-400"></span>
            <div className="blog-date text-xs sm:text-sm text-gray-600">
              {data.date}
            </div>
          </div>

          <div className="body1 text-gray-600 mt-3 text-sm sm:text-base">
            {data.h1Content.text?.length > 100
              ? `${data.h1Content.text.slice(0, 100)}...`
              : data.h1Content.text}
          </div>

          <div className="text-button font-medium underline mt-4 text-sm hover:text-gray-700 transition-colors">
            Read More
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogItem;
